import * as React from 'react';
import { DisplayDate, formatShortMonthDay } from 'owa-datetime';
import { observer } from 'mobx-react';
let classNames = require('classnames');
let styles = require('./CalendarAllDaySurfaceItem.scss');

export interface ContinuationDateProps {
    date: DisplayDate;
}

@observer
export default class ContinuationDate extends React.Component<ContinuationDateProps, {}> {
    render() {
        return (
            <div className={classNames(styles.icon, styles.continuationDate)}>
                {formatShortMonthDay(this.props.date)}
            </div>
        );
    }
}
